/**
 * M3X.WORKSPACE-CLOSURE Session 2.6 PR 2 — defensive useAuth wrapper.
 *
 * Clerk's `useAuth()` throws when called outside a `<ClerkProvider>`.
 * Some isolated component tests render Rail2 / WorkspaceShell-children
 * without that wrapper, so we need a hook that gracefully returns
 * `null` instead of crashing.
 *
 * Convention: every chassis component that depends on the user id
 * (for per-user localStorage keys) calls this instead of useAuth
 * directly.
 */

import { useAuth } from "@clerk/clerk-react";


export function useOptionalUserId(): string | null {
  try {
    return useAuth().userId ?? null;
  } catch {
    // Outside ClerkProvider (test surfaces, storybook, etc.) — treat
    // as anonymous; downstream localStorage keys use the "anon" fallback.
    return null;
  }
}
